<span data-inner>
  @if (icon(); as iconName) {
    <span data-leading>
      <bspk-icon [name]="iconName" />
    </span>
  }

  <span bspk-txt="labels-small">{{ label() }}</span>

  @if (removable()) {
    <span data-remove role="button" [attr.aria-label]="'Remove ' + label()" (click)="removed.emit()">
      <bspk-icon name="Close" />
    </span>
  }
</span>
